/*
 * Public API Surface of ng-boring-avatars
 */

export * from './lib/ng-boring-avatars.module';

export * from './lib/avatar-bauhaus/avatar-bauhaus.module';
export * from './lib/avatar-bauhaus/avatar-bauhaus.component';

export * from './lib/avatar-beam/avatar-beam.module';
export * from './lib/avatar-beam/avatar-beam.component';

export * from './lib/avatar-marble/avatar-marble.module';
export * from './lib/avatar-marble/avatar-marble.component';

export * from './lib/avatar-pixel/avatar-pixel.module';
export * from './lib/avatar-pixel/avatar-pixel.component';

export * from './lib/avatar-ring/avatar-ring.module';
export * from './lib/avatar-ring/avatar-ring.component';

export * from './lib/avatar-sunset/avatar-sunset.module';
export * from './lib/avatar-sunset/avatar-sunset.component';
